var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxSearchAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38424 15.6347C9.08815 15.6347 10.6545 15.0486 11.9043 14.0766L15.962 18.1343L17.2671 16.8291L13.2095 12.7715C14.1824 11.5207 14.7685 9.95436 14.7685 8.25045C14.7685 4.17897 11.4557 0.866211 7.38424 0.866211C3.31275 0.866211 0 4.17897 0 8.25045C0 12.3219 3.31275 15.6347 7.38424 15.6347ZM7.38393 2.71207C10.4382 2.71207 12.9221 5.19594 12.9221 8.25025C12.9221 11.3046 10.4382 13.7884 7.38393 13.7884C4.32963 13.7884 1.84575 11.3046 1.84575 8.25025C1.84575 5.19594 4.32963 2.71207 7.38393 2.71207ZM9.22989 8.24986C9.22989 7.75881 9.03698 7.29545 8.68715 6.9447C7.98934 6.24873 6.78017 6.24689 6.07867 6.94654L4.77535 5.63953C6.17189 4.24391 8.59485 4.24391 9.99232 5.63953C10.692 6.34011 11.076 7.26683 11.076 8.24986H9.22989Z",
    fill: "#8A8A95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxSearchAlt);
export default __webpack_public_path__ + "static/media/bx-search-alt.7b24c82d4c5a45726bae6dd035e7c98c.svg";
export { ForwardRef as ReactComponent };